import React, { useContext } from 'react'
import { FormContext } from '../../context/form/FormContext';
// import { LanguageContext } from '../../context/language/LanguageContext';
import QuestionName from '../styleComponents/QuestionName';

const ShortAnswer = ({ id, question, qDescription, answer }) => {
    const { handleChange } = useContext(FormContext)
    // const {lang} = useContext(LanguageContext);
    return (
        <div className="mb-5">
            <QuestionName questionName={question} description={qDescription}/>
            <input
                autoFocus
                placeholder='Escribe tu respuesta'
                aria-describedby="emailHelp"
                className="form-control fs-4 p-3"
                id={`${question}-${id}`}
                key={`${question}-${id}`}
                name={`${question}-${id}`}
                onChange={event=>handleChange(id,event)} 
                type="text"
                value={answer || ''}
            />
        </div>
    )
}

export default ShortAnswer
